import { SET_BIDS, CLEAR_BIDS } from '../actionTypes'

const initialState = []

   

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_BIDS:
            return action.bids || initialState
        case CLEAR_BIDS:
            return initialState
        default:
            return state
    }
}